<template>
  <modal :is-active="isActive" @close="close" :size="'md'">
    <template #header>
      <span class="pull-right text-primary cursor--pointer" @click="close">
        <i class="fa fa-times"></i>
      </span>
    </template>
    <template #body>
      <h3>{{ $t('configurator.headings.summary') }}</h3>
      <table class="table summery-table article-table">
        <thead>
          <tr>
            <th class="hidden-xs"></th>
            <th>{{ $t("basket.item") }}</th>
            <th class="text-right">{{ (!basket.net_value_only) ? $t("basket.netPrice") : $t("basket.price_in") }}</th>
            <th v-if="!basket.net_value_only" class="text-right">{{ $t("basket.vatPrice") }}</th>
            <th v-if="!basket.net_value_only" class="text-right">{{ $t("basket.price_in") }}</th>
          </tr>
        </thead>
        <template v-for="printItem in printItems" :key="printItem.id">
          <print-cloud-summary-article :article="printItem">
          </print-cloud-summary-article>
        </template>
        <tbody v-if="basket.print_items.length === 0">
          <tr>
            <td class="text-center" :colspan="basket.net_value_only ? 3 : 5">
              {{ $t('configurator.labels.no_prints_selected') }}
            </td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <th class="hidden-xs"></th>
            <th :colspan="basket.net_value_only ? 1 : 3">{{ $t("basket.item") }}</th>
            <th class="text-right">{{ $t("basket.price_in") }}</th>
          </tr>
        </thead>

        <tfoot>
          <tr v-if="basket.late_delivery_active && !earlyBirdMode">
            <td></td>
            <td :colspan="basket.net_value_only ? 1 : 3">
              {{ $t("basket.late_delivery") }} ({{ basket.late_delivery.surcharge_in_percent }}%):
            </td>
						<td class="text-right">{{ $filters.formatMoney(basket.total_late_delivery) }}</td>
          </tr>
          <tr>
						<th class="hidden-xs"></th>
            <th :colspan="basket.net_value_only ? 1 : 3">
              {{ $t("basket.total") }}:
            </th>
            <th class="text-right">
              {{ $filters.formatMoney(basket.total) }}
            </th>
          </tr>
          <tr v-if="!basket.net_value_only">
						<th class="hidden-xs"></th>
            <th :colspan="3">
              {{ $t("basket.total_gross_summary") }}:
            </th>
            <th class="text-right">
              {{ $filters.formatMoney(basket.total_gross) }}
            </th>
          </tr>
        </tfoot>
      </table>
      <h3>{{ $t('labels.contact_data') }}</h3>
			<h5><strong>{{ $t('labels.client') }}</strong></h5>
      <div class="form-group pc-order-modal__contact-grid">
        <label>{{ (request.country_legal_form === null) ? $t('forms.company_and_legal_form') : $t('forms.company') }}:</label>
        <span>{{  request.company  }}</span>
        <label v-if="request.country_legal_form">{{ $t('forms.legal_form') }}:</label>
        <span v-if="request.country_legal_form">{{  request.country_legal_form.name_local }}</span>
        <label>{{ $t('forms.name') }}:</label>
        <span>{{  request.name  }}</span>
        <label>{{ $t('forms.email') }}:</label>
        <span>{{  request.email  }}</span>
        <label>{{ $t('forms.street_name') }}:</label>
        <span>{{  request.street_name  }} {{  request.street_number }}</span>
        <label>{{ $t('forms.zip_place') }}:</label>
        <span>{{  request.zip  }} {{  request.place }}</span>
        <label>{{ $t('forms.country') }}:</label>
        <span>{{ !inEnglish ? request.country.name : request.country.name_english }}</span>
        <label>{{ $t('forms.vat_id') }}:</label>
        <span>{{ request.vat_id }}</span>
        <label>{{ $t('forms.hall') }}:</label>
        <span>{{ request.exhibition_hall }}</span>
        <label>{{ $t('forms.booth_number') }}:</label>
        <span>{{ request.exhibition_booth_number }}</span>
      </div>
      <div class="form-group" :class="{'has-error': form.errors.has('use_order_number')}">
        <label for="use_order_number">{{ $t('forms.use_order_number') }} <span>*</span> :</label>
        <div class="radio">
          <label>
            <input
              type="radio"
              name="use_order_number"
              id="use_order_number2"
              key="input-use-order-number-two"
              :value="true"
              v-model="form.use_order_number"
              style="width: 13px">
            {{ $t('labels.yes') }}
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              type="radio"
              name="use_order_number"
              id="use_order_number1"
              :value="false"
              v-model="form.use_order_number"
              style="width: 13px">
            {{ $t('labels.no') }}
          </label>
        </div>
      </div>
      <p v-if="form.errors.has('use_order_number')"
        class="text-danger"
        v-html="$t('errors.use_order_number')">
      </p>

      <div v-if="form.use_order_number"
        class="form-group"
        :class="{'has-error': form.errors.has('order_number')}">
        <label for="order_number">{{ $t('forms.order_number') }} <span>*</span> :</label>
        <input
          type="text"
          class="form-control input-sm"
          id="order_number"
          key="input-order-number"
          name="order_number"
          :placeholder='$t("forms.placeholders.order_number")'
          v-model.trim="form.order_number">
      </div>
      <p class="text-danger" v-if="form.use_order_number && form.errors.has('order_number')">
        {{ $t('errors.order_number') }}
      </p>
      <div v-if="form.use_order_number === false"
        class="form-group"
        :class="{'has-error': form.errors.has('order_number')}">
        <p><b>{{ $t('forms.order_number_notice') }}</b></p>
      </div>
      <div class="form-group">
        <label for="comment">{{ $t('forms.comment') }}:</label>
        <textarea
          name="comment"
          id="comment"
          class="form-control input-sm"
          style="resize: vertical"
          v-model="form.comment"
          rows="5"
          :placeholder='$t("forms.placeholders.comment")'>
        </textarea>
      </div>

      <!-- optional bill Address -->
      <h5 style="margin-top: 24px"><strong>{{ $t('labels.different_billing_address') }}</strong></h5>
      <div class="form-group">
        <p><b>{{ $t('forms.bill_address_notice') }}</b></p>
      </div>
      <div class="form-group">
        <div class="text-center">
          <button type="button" class="btn btn-warning" @click="toggleHasBillAddress">
            {{ form.has_bill_address ? $t("labels.remove_bill_address") : $t("labels.add_bill_address") }}
          </button>
        </div>
      </div>

      <div v-if="form.has_bill_address" :key="form.has_bill_address">
        <div class="form-group bill" :class="{'has-error': form.errors.has('bill_country_id')}">
          <label for="bill_country_id" class="control-label">{{ $t('forms.country') }}</label>
          <select
            id="bill_country_id"
            v-model="form.bill_country_id"
            class="form-control">
            <option v-for="country in countryOptions"
              :value="country.id"
              :key="country.id">
              {{ !inEnglish ? country.name : country.name_english }}
            </option>
          </select>
        </div>

        <div class="form-group bill">
          <div class="row">
            <label for="bill_company" class="col-md-12 control-label">{{ $t('forms.company') }}*:</label>
            <div class="col-md-12" :class="{'has-error': form.errors.has('bill_company')}">
              <input
                id="bill_company"
                name="bill_company"
                key="input-bill-company"
                type="text"
                class="form-control input-sm"
                v-model.trim="form.bill_company">
            </div>
          </div>
        </div>

        <div v-if="availableLegalForms.length > 0" class="form-group" :class="{'has-error': form.errors.has('bill_country_legal_form_id')}">
          <label for="bill_country_legal_form_id" class="control-label">{{ $t('forms.legal_form') }}*</label>
          <select
            id="bill_country_legal_form_id"
            v-model="form.bill_country_legal_form_id"
            class="form-control">
            <option v-for="legalForm in availableLegalForms"
              :value="legalForm.id"
              :key="legalForm.id">
              {{ legalForm.name_local }}
            </option>
          </select>
        </div>

        <div class="form-group bill">
          <div class="row">
            <label for="bill_name" class="col-md-12 control-label">{{ $t('forms.bill_name') }}*</label>
            <div class="col-md-12" :class="{'has-error': form.errors.has('bill_name')}">
              <input
                id="bill_name"
                name="bill_name"
                key="input-bill-name"
                type="text"
                class="form-control input-sm"
                :placeholder="$t('forms.placeholders.bill_name')"
                v-model.trim="form.bill_name">
            </div>
          </div>
          <!--<p class="text-danger" v-if="errors.has('bill_name')">{{ errors.first('bill_name') }}</p>-->
        </div>
        <div class="form-group bill">
          <div class="row">
            <label for="bill_street_name" class="col-md-12 control-label">{{ $t('forms.street_name')
              }}*</label>
            <div class="col-md-9" :class="{'has-error': form.errors.has('bill_street_name')}">
              <input
                id="bill_street_name"
                name="bill_street_name"
                key="input-bill-street-name"
                type="text"
                class="form-control input-sm"
                :placeholder="$t('forms.placeholders.street_name')"
                v-model.trim="form.bill_street_name">
            </div>
            <div class="col-md-3" :class="{'has-error': form.errors.has('bill_street_number')}">
              <input
                id="bill_street_number"
                name="bill_street_number"
                key="input-bill-street-number"
                type="bill_street_number"
                class="form-control input-sm"
                :placeholder="$t('forms.placeholders.street_number')"
                v-model.trim="form.bill_street_number">
            </div>
          </div>
        </div>
        <div class="form-group bill">
          <div class="row">
            <label for="bill_zip" class="col-md-12 control-label">{{ $t('forms.bill_zip_place') }}*</label>
            <div class="col-md-3" :class="{'has-error': form.errors.has('bill_zip')}">
              <input
                id="bill_zip"
                name="bill_zip"
                key="input-bill-zip"
                type="bill_zip"
                class="form-control input-sm"
                :placeholder="$t('forms.placeholders.zip')"
                v-model.trim="form.bill_zip">
            </div>
            <div class="col-md-9" :class="{'has-error': form.errors.has('bill_place')}">
              <input
                id="bill_place"
                name="bill_place"
                key="input-bill-place"
                type="text"
                class="form-control input-sm"
                :placeholder="$t('forms.placeholders.place')"
                v-model.trim="form.bill_place">
            </div>
          </div>
        </div>

        <div class="form-group bill row" :class="{'has-error': form.errors.has('bill_vat_id')}">
          <label for="bill_vat_id" class="col-md-12 control-label">
            {{ $t('forms.vat_id') }} <span v-show="isBillVatRequired">*</span>:
          </label>
          <div class="col-md-2">
            <select
              id="bill_vat_id_prefix"
              v-model="form.bill_vat_id_prefix"
              class="form-control">
              <option v-for="country in countryCodeOptions" v-bind:value="country.country_code" :key="country.id">
                {{ country.country_code }}
              </option>
            </select>
          </div>
          <div class="col-md-10">
            <input
              type="text"
              class="form-control"
              id="bill_vat_id"
              key="input-bill-vat-id"
              name="bill_vat_id"
              :placeholder='$t("forms.placeholders.vat_id")'
              v-model.trim="form.bill_vat_id"
              @keyup="checkVatId">
          </div>
        </div>
        <p class="text-danger" v-if="isBillVatRequired && form.bill_vat_id && !billVatIdValid">
          {{ $t('errors.vat_id') }}
        </p>
        <div class="form-group bill" :class="{'has-error': form.errors.has('bill_email') }">
          <label class="control-label" for="bill_email">{{ $t('forms.email') }}*:</label>
          <input
            id="bill_email"
            name="bill_email"
            key="input-bill-email"
            class="form-control input-sm"
            type="email"
            :placeholder='$t("forms.placeholders.email")'
            v-model.trim="form.bill_email">
        </div>
        <div class="form-group bill" :class="{'has-error': form.errors.has('bill_phone')}">
          <label for="bill_phone" class="control-label">{{ $t('forms.phone') }}</label>
          <input
            id="bill_phone"
            name="bill_phone"
            key="input-bill-phone"
            type="text"
            class="form-control input-sm"
            v-model.trim="form.bill_phone"
            :placeholder="$t('forms.placeholders.phone')">
        </div>
      </div>
      <div class="form-group">
        <label v-html="generalTermsLink"></label>
      </div>

      <div class="form-group">
        <hr>
        <div class="text-center">
          <button type="button"
            class="btn btn-primary"
            @click="submit"
            :disabled="isSubmitButtonDisabled">
            {{ $t("labels.submit_request") }}
          </button>
        </div>
        <div class="text-center mt-2">
          <a @click="close" class="cursor--pointer">
            {{ $t('configurator.buttons.cancel') }}
          </a>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import Form from '@/classes/Form'
import { computed, ref, watch } from 'vue'
import { useMainStore } from '@/store'
import { useI18n } from 'vue-i18n'
import { validateVatId } from '@/utils/vat'
import { cloneDeep } from 'lodash'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define props
const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
  form: {
    type: Form,
    required: true
  },
  countries: {
    type: Array,
    default: []
  },
  request: {
    type: Object,
    required: true
  }
})
// define emits
const emit = defineEmits(['close', 'submit'])
// define reactive props
const billVatIdValid = ref(true)
// define computed props
const locale = computed(() => store.settings.locale)
const basket = computed(() => store.print.basket)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const isSubmitButtonDisabled = computed(() => {
  if (basket.value.print_items.length === 0) {
    return true
  }

  if (
    props.form.use_order_number
    && (props.form.order_number === null || props.form.order_number.trim().length === 0)
  ) {
    return true
  }

  if (!props.form.has_bill_address) {
    return false
  }

  return !(
    billVatIdValid.value
    && props.form.bill_company
    && props.form.bill_name
    && props.form.bill_street_name
    && props.form.bill_street_number
    && props.form.bill_zip
    && props.form.bill_place
    && props.form.bill_email
  )
})


const generalTermsLink = computed(() => {
	const file = (inEnglish.value)
		? '/terms/LUECO-General-Conditions-of-Delivery-and-Payment.pdf'
		: '/terms/LUECO-Allgemeine-Geschaeftsbedingungen.pdf'

	return (t('labels.general_terms_submit').replace('[path_to_general_terms]' , file))
})

const isBillVatRequired = computed(() => {
  if (props.countries.length === 0 || props.form.bill_country_id === null) {
    return false
  }

  const index = props.countries.findIndex((country) => country.id === props.form.bill_country_id)
  if (index > -1) {
    return props.countries[index].has_vat
  }
  
  return false
})

const printItems = computed(() => {
	const items = {}
	basket.value.print_items.forEach((item) => {
		if (!items.hasOwnProperty(item.article_id)) {
			items[item.article_id] = cloneDeep(item)
		} else {
			items[item.article_id].count += item.count
			items[item.article_id].count_after_inclusive += item.count_after_inclusive
			items[item.article_id].inclusive += item.inclusive
		}
	})

	return Object.values(items)
})

const availableLegalForms = computed(() => {
	if (props.form.bill_country_id === null) {
		return []
	}

	const country = props.countries.find((country) => country.id === props.form.bill_country_id)

	return country.legal_forms
		.sort((a, b) => {
			return b.name_local.localeCompare(a.name_local)
		})
		.reverse()
})

const countryCodeOptions = computed(() => {
	return props.countries.filter((country) => country.country_code !== null && country.country_code.trim() !== '')
		.sort((a, b) => {
			return b.country_code.localeCompare(a.country_code)
		})
		.reverse()
})

const countryOptions = computed(() => {
	return props.countries
		.sort((a, b) => {
			return (inEnglish.value)
        ? b.name_english.localeCompare(a.name_english)
        : b.name.localeCompare(a.name)
		})
		.reverse()
})
// define watches
watch(() => props.form.bill_country_id, () => {
  setBillVatIdPrefix()
  checkVatId()
  props.form.bill_country_legal_form_id = null
})
// define methods
const setBillVatIdPrefix = () => {
  if (props.form.bill_country_id === null) {
    props.form.bill_vat_id_prefix = ''
  }
  let index = props.countries.findIndex((item) => item.id === props.form.bill_country_id)

	if (index > -1) {
		props.form.bill_vat_id_prefix = props.countries[index].country_code
	} else {
		props.form.bill_vat_id_prefix = ''
	}
}
const toggleHasBillAddress = () => {
  props.form.has_bill_address = !props.form.has_bill_address
}

const submit = () => {
  emit('submit')
}

const close = () => {
  emit('close')
}

const checkVatId = _.debounce(async () => {
  if (!isBillVatRequired.value) {
    billVatIdValid.value = true

    return
  }
  await validateVatId(props.form.bill_vat_id_prefix + props.form.bill_vat_id)
    .then(response => {
      billVatIdValid.value = response
    })
    .catch(err => {
      console.error(err)
      billVatIdValid.value = false
    })
}, 250)
</script>